/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_appsync_graphqlEndpoint": "https://odx3wlw4nrbnfdmaqcley4xuyu.appsync-api.eu-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-5cg4aibpbzhhzlcy4wrcnlpzby",
    "aws_cloud_logic_custom": [
        {
            "name": "checkout",
            "endpoint": "https://pw5xj6ydkj.execute-api.eu-west-2.amazonaws.com/admin",
            "region": "eu-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-2:5d48084c-bd68-4bbe-b145-34f6756460cf",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_5wDVTIGGc",
    "aws_user_pools_web_client_id": "3gcvgnfqh3nef9r3ghnh9feior",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "amplifyapp15babf61e9a3434db5e4ba3de07ba21d181423-admin",
    "aws_user_files_s3_bucket_region": "eu-west-2"
};


export default awsmobile;
